import { AgencyErrorTypes } from "../routes/agency-worker/AgencyErrorTypes";
export var getAgencyMessageId = function (errorCode) {
    switch (errorCode) {
        case AgencyErrorTypes.DUPLICATE:
            return "ui-br-agency.agency-prefix.submit.duplicity";
        case AgencyErrorTypes.CHILDREN:
            return "ui-br-agency.agency-prefix.delete.children";
        default:
            return "ui-br-agency.agency-prefix.submit";
    }
};
